import { Button } from '../ui/Button';
import { devicesUpTo } from '../../utils/pluralize';
import {
  CDN_TITLE,
  PLAN_FEATURE_UNLIMITED,
  cdnPlanFeatureValue,
  extraKeyFeature,
} from '../../texts/cdn';
import styles from './PlanCard.module.css';

interface PlanCardProps {
  name: string;
  priceKopecks: number;
  durationDays: number;
  maxDevices: number;
  /** Квота обхода белых списков в месяц (байты); 0 — фичу не показываем */
  cdnTrafficBytesPerMonth?: number;
  /** Цена доп. ключа; 0 — «Доп. ключи недоступны» */
  extraKeyPriceKopecks?: number;
  popular?: boolean;
  onSelect: () => void;
  loading?: boolean;
}

export function PlanCard({
  name,
  priceKopecks,
  durationDays,
  maxDevices,
  cdnTrafficBytesPerMonth = 0,
  extraKeyPriceKopecks = 0,
  popular = false,
  onSelect,
  loading = false,
}: PlanCardProps) {
  const priceRub = priceKopecks / 100;
  const months = Math.round(durationDays / 30);
  const perMonth = months > 1 ? Math.round(priceRub / months) : null;

  return (
    <div className={`${styles.card} ${popular ? styles.highlighted : ''}`}>
      {popular && <span className={styles.popularBadge}>Популярный</span>}
      <div className={styles.name}>{name}</div>
      <div className={styles.price}>
        {priceRub} <span className={styles.priceUnit}>₽</span>
      </div>
      {perMonth && (
        <div className={styles.perMonth}>~{perMonth} ₽/мес</div>
      )}
      <ul className={styles.features}>
        <li>{devicesUpTo(maxDevices)}</li>
        <li>Все локации</li>
        <li>{PLAN_FEATURE_UNLIMITED}</li>
        {cdnTrafficBytesPerMonth > 0 && (
          <li className={styles.featureKey}>
            <span>{CDN_TITLE}:</span>
            <strong className={styles.featureValue}>
              {cdnPlanFeatureValue(cdnTrafficBytesPerMonth)}
            </strong>
          </li>
        )}
        <li>{extraKeyFeature(extraKeyPriceKopecks)}</li>
        <li>Мгновенная активация</li>
      </ul>
      <Button fullWidth onClick={onSelect} loading={loading} variant={popular ? 'primary' : 'secondary'}>
        Подключить
      </Button>
    </div>
  );
}
